/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbAcquisProfessionnelGridDto } from './FcbAcquisProfessionnelGridDto';
import {
    FcbAcquisProfessionnelGridDtoFromJSON,
    FcbAcquisProfessionnelGridDtoFromJSONTyped,
    FcbAcquisProfessionnelGridDtoToJSON,
} from './FcbAcquisProfessionnelGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbAcquisProfessionnelGridDtoPaginatedResults
 */
export interface FcbAcquisProfessionnelGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbAcquisProfessionnelGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbAcquisProfessionnelGridDto>}
     * @memberof FcbAcquisProfessionnelGridDtoPaginatedResults
     */
    results?: Array<FcbAcquisProfessionnelGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbAcquisProfessionnelGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbAcquisProfessionnelGridDtoPaginatedResults interface.
 */
export function instanceOfFcbAcquisProfessionnelGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAcquisProfessionnelGridDtoPaginatedResultsFromJSON(json: any): FcbAcquisProfessionnelGridDtoPaginatedResults {
    return FcbAcquisProfessionnelGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbAcquisProfessionnelGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAcquisProfessionnelGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbAcquisProfessionnelGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbAcquisProfessionnelGridDtoPaginatedResultsToJSON(value?: FcbAcquisProfessionnelGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbAcquisProfessionnelGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

